import { defineMessages } from 'utils/intl';

export default defineMessages({
  trackingEnabled: 'Analityka została włączona',
  trackingDisabled: 'Analityka została wyłączona',
});
